export default __webpack_public_path__ + "static/media/img-0802-greece-half-face.35f55ea9.png";